import { GanttRow, Project } from '../types';

/**
 * Build hierarchical GanttRow[] from a project's zone structure.
 *
 * Both DashboardPage and CalendarPage need the same zone -> section -> element -> task
 * mapping. This utility eliminates the duplication.
 */
export function buildGanttRows(project: Project): GanttRow[] {
  return project.zones.map(zone => ({
    id: zone.id,
    code: zone.code,
    name: zone.name,
    type: 'zone' as const,
    level: 0,
    children: zone.sections.map(sec => ({
      id: sec.id,
      code: sec.code,
      name: sec.name,
      type: 'section' as const,
      level: 1,
      children: sec.elements.map(el => ({
        id: el.id,
        code: el.code,
        name: el.name,
        type: 'element' as const,
        level: 2,
        children: el.subElements
          .filter(se => se.startDate && se.endDate)
          .map(se => ({
            id: se.id,
            code: se.code,
            name: se.name,
            type: 'task' as const,
            level: 3,
            startDate: se.startDate,
            endDate: se.endDate,
            status: se.status,
            assignedTo: se.assignedTo,
          })),
      })),
    })),
  }));
}
